export const SUPPORT_IFRAME = 'hs-web-sdk-iframe';
export const SUPPORT_IFRAME_LAUNCHER = 'hs-web-sdk-iframe-launcher';

export const isCheckoutLink = (url: string = window.location.href): boolean => {
  const urlObj = new URL(url, window.location.origin);
  return urlObj.searchParams.get('from') === 'campaign';
};
